<template>

  <section class="what section" id="what">
      <ul class="list list--services-blocks">
          <li class="list__item">
                  <div class="list__item-inner">
                      <div class="img-wrap" style="background-image: url('static/img/what/ios-dev-hero.jpg')"></div>
                      <div class="list__item-content">
                          <h3 class="title">iOS <br>Development</h3>
                          <p class="text">We use modern programming languages, such as Swift and Objective-C, and proven technologies and approaches that allow us to easily extend and scale our products.</p>
                      </div>
                  </div>
              </li>
          <li class="list__item">
                  <div class="list__item-inner">
                      <div class="img-wrap" style="background-image: url('static/img/what/android-dev-hero.jpg')"></div>
                      <div class="list__item-content">
                          <h3 class="title">Android <br>Development</h3>
                          <p class="text">We develop Android apps in Java and Kotlin. Given the broad range of devices capable of running Android, we can create apps for everything from smartwatches to smart TVs.</p>
                      </div>
                  </div>
              </li>
          <li class="list__item">
                  <div class="list__item-inner">
                      <div class="img-wrap" style="background-image: url('static/img/what/ux-ui-st-hero.jpg')"></div>
                      <div class="list__item-content">
                          <h3 class="title">UI/UX <br>Design</h3>
                          <p class="text">We offer prototyping, branding, UI and UX design for web and mobile products. Our approach is simple: we focus on how actual people will use our clients’ products.</p>
                      </div>
                  </div>
              </li>
          <li class="list__item">
                  <div class="list__item-inner">
                      <div class="img-wrap" style="background-image: url('static/img/what/web-dev-hero.jpg')"></div>
                      <div class="list__item-content">
                          <h3 class="title">Web <br>Development</h3>
                          <p class="text">We provide both frontend and backend development services. Our web development team specializes in Ruby on Rails, Go, JavaScript, AngularJS, React, Node.js, and Elixir.</p>
                      </div>
                  </div>
              </li>
          <li class="list__item">
                  <div class="list__item-inner">
                      <div class="img-wrap" style="background-image: url('static/img/what/pm-st-hero.jpg')"></div>
                      <div class="list__item-content">
                          <h3 class="title">Project <br>Management</h3>
                          <p class="text">Our dedicated project managers ensure that all your expectations and requirements are met, supervise your team’s performance, and make sure that your product is delivered on schedule.</p>
                      </div>
                  </div>
              </li>
          <li class="list__item">
                  <div class="list__item-inner">
                      <div class="img-wrap" style="background-image: url('static/img/what/qa-st-hero.jpg')"></div>
                      <div class="list__item-content">
                          <h3 class="title">Quality <br>Assurance</h3>
                          <p class="text">Our quality control team verifies that developed functionality meets business objectives and ensures that code is relatively bug-free by applying manual and automated testing.</p>
                      </div>
                  </div>
              </li>
      </ul>
  </section>

</template>

<script>
export default {
  name: 'What',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section {padding:0;}
a, a:active, a:focus, a:active { text-decoration:none!important; }
.list--services-blocks{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
}
@media (max-width: 768px){
    .list--services-blocks{
        margin:0
    }
}
@media (min-width: 570px) and (max-width: 992px){
    .list--services-blocks .list__item{
        width:50%;
        margin:0;
        float:left
    }
}
.list--services-blocks .list__item-inner:after{
    padding-top:100%
}
@media (max-width: 768px){
  .list--services-blocks .list__item-content:after{
        display:inline-block;
        margin-top:15px
    }
}
.list--services-blocks .img-wrap{
    opacity:0
}
@media (max-width: 768px){
    .list--services-blocks .img-wrap{
        opacity:1
    }
}

.list--services-blocks .title{
    font-size:48px
}
@media (max-width: 768px){
  .list--services-blocks .title{
        font-size:24px;
        margin:0
    }
}
.list--services-blocks br{
    display:block
}
.list--services-blocks:after{
    content:"";
    display:table;
    clear:both
}
.list--services-blocks .list__item{
    flex: 1 0 33%;
    padding:0
}
@media (max-width: 768px){
    .list--services-blocks .list__item{
        flex: 1 0 50%;
    }
}
.list--services-blocks .list__item--active{
    pointer-events:none
}
.list--services-blocks .list__item--active .list__item-content:after{
    content:'';
    width:70px;
    height:2px;
    background:#ffffff
}
.list--services-blocks .list__item--active .img-wrap:after{
    background:#f39005;
    opacity:0.9
}
.list--services-blocks .list__item-inner{
    overflow:hidden;
    position:relative;
    height:330px;
}
@media (max-width: 768px){
    .list--services-blocks .list__item-inner{
      min-height: 130px;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
}
.list--services-blocks .list__item-inner:after{
    content:'';
    display:block;
    padding:66.5% 0 0
}
@media (max-width: 768px){
    .list--services-blocks .list__item-inner:after{
        display:none
    }
}
.list--services-blocks .list__item-inner:hover .list__item-content:after{
    -webkit-transform:translate(50%, 0);
    -ms-transform:translate(50%, 0);
    transform:translate(50%, 0)
}
.list--services-blocks .list__item-inner:hover .img-wrap{
    opacity:1;
    -webkit-transform:scale(1.1);
    -ms-transform:scale(1.1);
    transform:scale(1.1)
}
@media (max-width: 768px){
    .list--services-blocks .list__item-inner:hover .img-wrap{
        -webkit-transform:none;
        -ms-transform:none;
        transform:none
    }
}
.list--services-blocks .list__item-content{
    color:#ffffff;
    padding:2em;
    width:100%;
    display:flex;
    justify-content: center;
    align-items:flex-start;
    flex-direction:column;

}
@media screen and (min-width: 768px) {
  .list--services-blocks .list__item-content{
    height: 330px;
    }
  }

@media (max-width: 768px){
    .list--services-blocks .list__item-content{
        position:static;
        -webkit-transform:none;
        -ms-transform:none;
        transform:none;
        max-width:initial
    }
}
// .list--services-blocks .list__item-content:after{
//     content:"\2192";
//     -webkit-transition:all 0.3s ease-in;
//     transition:all 0.3s ease-in;
//     display:inline-block;
//     color:#f16522;
//     font-size:28px;
//     line-height:1
// }
@media (max-width: 768px){
    .list--services-blocks .list__item-content:after{
        display:none
    }
}
.list--services-blocks .img-wrap{
    position:absolute;
    left:0;
    top:0;
    bottom:0;
    right:0;
    -webkit-transition:all 0.3s ease-in;
    transition:all 0.3s ease-in;
    background:no-repeat center;
    background-size:cover;
    z-index:-1
}
.list--services-blocks .img-wrap:after{
    content:'';
    position:absolute;
    left:0;
    top:0;
    bottom:0;
    right:0;
    background:#f39005;
    opacity:0.75
}
.list--services-blocks .title {
    font-family: 'ClanOT-ExtdNews';
    margin:0;
    text-transform: lowercase;
    color: white;
}
@media (max-width: 768px){
    .list--services-blocks .title{
        font-size:18px
    }
}
.list--services-blocks .text{
    font-size:1em !important;
    margin: 20px 0;
    opacity:0.8;
    text-shadow: 1px 1px 10px black;
}



</style>



// WEBPACK FOOTER //
// src/components/What.vue